import React, { useState } from 'react';
import { Box, ListItemIcon, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import CheckIcon from '@mui/icons-material/Check';
import { useTranslation } from 'react-i18next';
import { LANGUAGES } from '../../i18n';
import { useAuth } from '../../contexts/AuthContext';

/** Language switcher. When signed in, the choice is also saved on the user's account. */
export default function LanguageSelect({ variant }) {
    const { t, i18n } = useTranslation();
    const { setLanguage } = useAuth();
    const [anchor, setAnchor] = useState(null);
    const current = LANGUAGES.find(l => l.code === i18n.language) || LANGUAGES[0];

    const choose = (code) => {
        setAnchor(null);
        if (code !== i18n.language) setLanguage(code);
    };

    return (
        <>
            <Tooltip title={t('language.choose')}>
                <Box component="button" type="button" onClick={(e) => setAnchor(e.currentTarget)} aria-label={t('language.choose')} sx={{
                    display: 'flex', alignItems: 'center', gap: 0.5, px: 1, py: 0.6, borderRadius: '9px', cursor: 'pointer', font: 'inherit',
                    border: '1px solid', borderColor: variant === 'light' ? 'rgba(255,255,255,0.9)' : '#E2E8F0',
                    bgcolor: variant === 'light' ? 'rgba(255,255,255,0.75)' : '#fff', color: '#427898',
                    '&:hover': { borderColor: '#427898' },
                }}>
                    <LanguageIcon sx={{ fontSize: 17 }} />
                    <Typography component="span" sx={{ fontSize: 12.5, fontWeight: 700 }}>{current.short}</Typography>
                </Box>
            </Tooltip>
            <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  slotProps={{ paper: { sx: { minWidth: 170, borderRadius: 2, mt: 1 } } }}>
                {LANGUAGES.map(l => (
                    <MenuItem key={l.code} onClick={() => choose(l.code)} selected={l.code === current.code} sx={{ fontSize: 14 }}>
                        <ListItemIcon sx={{ minWidth: 30 }}>{l.code === current.code && <CheckIcon fontSize="small" sx={{ color: '#427898' }} />}</ListItemIcon>
                        {l.label}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}
